import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, Link, Paper, Stack, TextField, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loginName, setLoginName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await login(loginName.trim(), password);
      navigate('/cabinet/creatives');
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Ошибка входа');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, bgcolor: 'background.default' }}>
      <Paper sx={{ p: 3, width: '100%', maxWidth: 400 }} component="form" onSubmit={submit}>
        <Typography variant="h5" gutterBottom>
          Вход в кабинет
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Владелец, менеджер или клиентский администратор
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Логин"
            value={loginName}
            onChange={(e) => setLoginName(e.target.value)}
            autoFocus
            fullWidth
            required
          />
          <TextField
            label="Пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
          />
          {error && <Alert severity="error">{error}</Alert>}
          <Button type="submit" variant="contained" disabled={saving} fullWidth>
            {saving ? <CircularProgress size={22} /> : 'Войти'}
          </Button>
          <Link component={RouterLink} to="/" variant="body2" sx={{ textAlign: 'center' }}>
            ← На главную страницу
          </Link>
        </Stack>
      </Paper>
    </Box>
  );
};

export default LoginPage;
